export interface GridViewPageSizeOptionModel {
    value: number;
    label: string;
}